import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { Modal, ModalTopAction } from 'src/components/common';
import { InviteVerifiersAdminsByVerifierAdminModalForm } from 'src/components/verifierStaff';
import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';

import { InviteVerifiersAdminsByVerifierAdminModalArgs } from './types';

export const InviteVerifiersAdminsByVerifierAdminModal: React.FC = () => {
  const { isMobile } = useScreenInfo();
  const { closeModal, switchClosability, isOpen } =
    useModal<InviteVerifiersAdminsByVerifierAdminModalArgs>(
      ModalId.InviteVerifiersAdminsByVerifierAdmin,
    );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const mobileTopAction = React.useMemo((): ModalTopAction => {
    return {
      show: true,
      render: () => (
        <IconButton onClick={() => onCloseModal()}>
          <CloseIcon />
        </IconButton>
      ),
    };
  }, [onCloseModal]);

  return (
    <Modal
      title={isMobile ? 'Invite Staff' : 'Invite Verifiers'}
      topAction={isMobile ? mobileTopAction : undefined}
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
        fullScreen: isMobile,
      }}
    >
      <InviteVerifiersAdminsByVerifierAdminModalForm
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
